//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { AccountingEventExportResult, CouponBalanceResponse, CreateAccountingEventExportInput, CreateMarketOrderPurchaseOrderRequest, CreateMarketOrderRequest, DeleteMarketOrderRequest, IndexFreshnessResponse, MarketOrderListResponse, MarketOrderPurchaseOrderListResponse, MarketOrderPurchaseOrderQuery, MarketOrderPurchaseOrderResponse, MarketOrderQuery, MarketOrderResponse, ProblemDetails, ReportAssistantChatRequest, TeamAccountInput, TeamInfo, TeamInput, TeamMemberDto, TeamUpdateInput, UpdateMarketOrderRequest } from './types';


export interface IAccountingEventClient {

    createExport(input: CreateAccountingEventExportInput): Promise<AccountingEventExportResult>;

    getExport(exportId: number | undefined): Promise<AccountingEventExportResult>;
}

export class AccountingEventClient extends PosClientBase implements IAccountingEventClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createExport(input: CreateAccountingEventExportInput, signal?: AbortSignal | undefined): Promise<AccountingEventExportResult> {
        let url_ = this.baseUrl + "/api/AccountingEvent/CreateExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateExport(_response);
        });
    }

    protected processCreateExport(response: Response): Promise<AccountingEventExportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountingEventExportResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountingEventExportResult>(null as any);
    }

    getExport(exportId: number | undefined, signal?: AbortSignal | undefined): Promise<AccountingEventExportResult> {
        let url_ = this.baseUrl + "/api/AccountingEvent/GetExport?";
        if (exportId === null)
            throw new Error("The parameter 'exportId' cannot be null.");
        else if (exportId !== undefined)
            url_ += "exportId=" + encodeURIComponent("" + exportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExport(_response);
        });
    }

    protected processGetExport(response: Response): Promise<AccountingEventExportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountingEventExportResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountingEventExportResult>(null as any);
    }
}
export interface IIndexFreshnessClient {

    /**
     * Returns the data freshness timestamp for the specified entity index.
     * @param entity The entity type whose index to check: listings, sales, or purchaseorders.
     * @param bypassCache (optional) When true, bypasses the server-side cache and queries OpenSearch directly.
    Requires authentication. Note that live queries can take several seconds (P90 ~9 s).
     * @return 200 OK with an IndexFreshnessResponse on success;
    400 Bad Request for unknown entity types;
    500 Internal Server Error if the freshness service is unavailable.
     */
    getIndexFreshness(entity: string, bypassCache: boolean | undefined): Promise<IndexFreshnessResponse>;
}

export class IndexFreshnessClient extends PosClientBase implements IIndexFreshnessClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Returns the data freshness timestamp for the specified entity index.
     * @param entity The entity type whose index to check: listings, sales, or purchaseorders.
     * @param bypassCache (optional) When true, bypasses the server-side cache and queries OpenSearch directly.
    Requires authentication. Note that live queries can take several seconds (P90 ~9 s).
     * @return 200 OK with an IndexFreshnessResponse on success;
    400 Bad Request for unknown entity types;
    500 Internal Server Error if the freshness service is unavailable.
     */
    getIndexFreshness(entity: string, bypassCache: boolean | undefined, signal?: AbortSignal | undefined): Promise<IndexFreshnessResponse> {
        let url_ = this.baseUrl + "/api/{entity}/GetIndexFreshness?";
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (bypassCache === null)
            throw new Error("The parameter 'bypassCache' cannot be null.");
        else if (bypassCache !== undefined)
            url_ += "bypassCache=" + encodeURIComponent("" + bypassCache) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIndexFreshness(_response);
        });
    }

    protected processGetIndexFreshness(response: Response): Promise<IndexFreshnessResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IndexFreshnessResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndexFreshnessResponse>(null as any);
    }
}
export interface IMarketOrderClient {

    getCouponBalance(): Promise<CouponBalanceResponse>;

    getMarketOrders(query: MarketOrderQuery): Promise<MarketOrderListResponse>;

    getMarketOrder(marketOrderId: number | undefined): Promise<MarketOrderResponse>;

    createMarketOrder(request: CreateMarketOrderRequest): Promise<MarketOrderResponse>;

    updateMarketOrder(request: UpdateMarketOrderRequest): Promise<MarketOrderResponse>;

    deleteMarketOrder(request: DeleteMarketOrderRequest): Promise<void>;

    getMarketOrderPurchaseOrders(query: MarketOrderPurchaseOrderQuery): Promise<MarketOrderPurchaseOrderListResponse>;

    createMarketOrderPurchaseOrder(request: CreateMarketOrderPurchaseOrderRequest): Promise<MarketOrderPurchaseOrderResponse>;
}

export class MarketOrderClient extends PosClientBase implements IMarketOrderClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCouponBalance(signal?: AbortSignal | undefined): Promise<CouponBalanceResponse> {
        let url_ = this.baseUrl + "/api/MarketOrder/GetCouponBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCouponBalance(_response);
        });
    }

    protected processGetCouponBalance(response: Response): Promise<CouponBalanceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CouponBalanceResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CouponBalanceResponse>(null as any);
    }

    getMarketOrders(query: MarketOrderQuery, signal?: AbortSignal | undefined): Promise<MarketOrderListResponse> {
        let url_ = this.baseUrl + "/api/MarketOrder/GetMarketOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketOrders(_response);
        });
    }

    protected processGetMarketOrders(response: Response): Promise<MarketOrderListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketOrderListResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketOrderListResponse>(null as any);
    }

    getMarketOrder(marketOrderId: number | undefined, signal?: AbortSignal | undefined): Promise<MarketOrderResponse> {
        let url_ = this.baseUrl + "/api/MarketOrder/GetMarketOrder?";
        if (marketOrderId === null)
            throw new Error("The parameter 'marketOrderId' cannot be null.");
        else if (marketOrderId !== undefined)
            url_ += "marketOrderId=" + encodeURIComponent("" + marketOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketOrder(_response);
        });
    }

    protected processGetMarketOrder(response: Response): Promise<MarketOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketOrderResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketOrderResponse>(null as any);
    }

    createMarketOrder(request: CreateMarketOrderRequest, signal?: AbortSignal | undefined): Promise<MarketOrderResponse> {
        let url_ = this.baseUrl + "/api/MarketOrder/CreateMarketOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMarketOrder(_response);
        });
    }

    protected processCreateMarketOrder(response: Response): Promise<MarketOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketOrderResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketOrderResponse>(null as any);
    }

    updateMarketOrder(request: UpdateMarketOrderRequest, signal?: AbortSignal | undefined): Promise<MarketOrderResponse> {
        let url_ = this.baseUrl + "/api/MarketOrder/UpdateMarketOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMarketOrder(_response);
        });
    }

    protected processUpdateMarketOrder(response: Response): Promise<MarketOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketOrderResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketOrderResponse>(null as any);
    }

    deleteMarketOrder(request: DeleteMarketOrderRequest, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MarketOrder/DeleteMarketOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMarketOrder(_response);
        });
    }

    protected processDeleteMarketOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMarketOrderPurchaseOrders(query: MarketOrderPurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<MarketOrderPurchaseOrderListResponse> {
        let url_ = this.baseUrl + "/api/MarketOrder/GetMarketOrderPurchaseOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketOrderPurchaseOrders(_response);
        });
    }

    protected processGetMarketOrderPurchaseOrders(response: Response): Promise<MarketOrderPurchaseOrderListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketOrderPurchaseOrderListResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketOrderPurchaseOrderListResponse>(null as any);
    }

    createMarketOrderPurchaseOrder(request: CreateMarketOrderPurchaseOrderRequest, signal?: AbortSignal | undefined): Promise<MarketOrderPurchaseOrderResponse> {
        let url_ = this.baseUrl + "/api/MarketOrder/CreateMarketOrderPurchaseOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMarketOrderPurchaseOrder(_response);
        });
    }

    protected processCreateMarketOrderPurchaseOrder(response: Response): Promise<MarketOrderPurchaseOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketOrderPurchaseOrderResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketOrderPurchaseOrderResponse>(null as any);
    }
}
export interface IReportAssistantClient {

    chat(request: ReportAssistantChatRequest): Promise<void>;
}

export class ReportAssistantClient extends PosClientBase implements IReportAssistantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    chat(request: ReportAssistantChatRequest, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/ReportAssistant/chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChat(_response);
        });
    }

    protected processChat(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}
export interface ITeamClient {

    getTeams(): Promise<TeamInfo[]>;

    getTeamMembers(teamSellerUserId: string | undefined): Promise<TeamMemberDto[]>;

    createTeam(input: TeamInput): Promise<string>;

    updateTeam(input: TeamUpdateInput): Promise<boolean>;

    deactivateTeam(input: TeamAccountInput): Promise<boolean>;

    activateTeam(input: TeamAccountInput): Promise<boolean>;
}

export class TeamClient extends PosClientBase implements ITeamClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTeams(signal?: AbortSignal | undefined): Promise<TeamInfo[]> {
        let url_ = this.baseUrl + "/api/Team/GetTeams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTeams(_response);
        });
    }

    protected processGetTeams(response: Response): Promise<TeamInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamInfo[]>(null as any);
    }

    getTeamMembers(teamSellerUserId: string | undefined, signal?: AbortSignal | undefined): Promise<TeamMemberDto[]> {
        let url_ = this.baseUrl + "/api/Team/GetTeamMembers?";
        if (teamSellerUserId === null)
            throw new Error("The parameter 'teamSellerUserId' cannot be null.");
        else if (teamSellerUserId !== undefined)
            url_ += "teamSellerUserId=" + encodeURIComponent("" + teamSellerUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTeamMembers(_response);
        });
    }

    protected processGetTeamMembers(response: Response): Promise<TeamMemberDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamMemberDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberDto[]>(null as any);
    }

    createTeam(input: TeamInput, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Team/CreateTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTeam(_response);
        });
    }

    protected processCreateTeam(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateTeam(input: TeamUpdateInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Team/UpdateTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTeam(_response);
        });
    }

    protected processUpdateTeam(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deactivateTeam(input: TeamAccountInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Team/DeactivateTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeactivateTeam(_response);
        });
    }

    protected processDeactivateTeam(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    activateTeam(input: TeamAccountInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Team/ActivateTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActivateTeam(_response);
        });
    }

    protected processActivateTeam(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}
